function extractVueFunctions () {
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frontmatter-markdown"},[_c('h3',[_c('strong',[_vm._v("Storefront")])]),_vm._v(" "),_c('p',[_vm._v("Offline Retailers of Premium Goods, Automotive Retailers")]),_vm._v(" "),_c('h3',[_vm._v("Connect past online behavior with offline showroom sales")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Measure ROI on online advertising")]),_vm._v(" "),_c('li',[_vm._v("High precision of post-visitation online communication (better conversion rate)")]),_vm._v(" "),_c('li',[_vm._v("Optimise online advertising costs")]),_vm._v(" "),_c('li',[_vm._v("Improve understanding of online channels effectiveness")])])])}]

return { render, staticRenderFns }
}
const vueFunctions = extractVueFunctions()

module.exports = { 
      attributes: {"href":"/use-cases/storefront","image":"/img/use-cases/u-03.svg","title":"Storefront"},
    
      vue: {
        component: {
          data: function () {
            return {
              templateRender: null
            }
          },
          render: function (createElement) {
            return this.templateRender ? this.templateRender() : createElement("div", "Rendering");
          },
          created: function () {
            this.templateRender = vueFunctions.render;
            this.$options.staticRenderFns = vueFunctions.staticRenderFns;
          }
        }
      },
     }